module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NTAiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgNzIgNDgiPjxwYXRoIGZpbGw9IiMwMDllNjAiIGQ9Ik0wIDBoNzJ2NDhIMHoiLz48cGF0aCBmaWxsPSIjZmNkMTE2IiBkPSJNMCAwaDU0djQ4SDB6Ii8+PHBhdGggZmlsbD0iIzAwNzJjNiIgZD0iTTAgMGgxOHY0OEgweiIvPjxnIGZpbGw9IiMwMDllNjAiPjxwYXRoIGQ9Ik0zMiAzNGw0IDggNC04LTQtOHpNMjcgMjRsNCA4IDQtOC00LTh6TTM3IDI0bDQgOCA0LTgtNC04eiIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/vct.svg
// module id = 25um
// module chunks = 0